// @flow
import JQueryView, { on } from '../../../common/JQueryView';
import DateRangePicker from '../../../common/DateRangePicker';

declare var $: any;

export default class Form2View extends JQueryView {
  constructor() {
    super('#form2');
    this.initDateRangePicker(this.$el);
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        locale: {
          format: 'Y/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'Y/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  @on({ event: 'click', selector: '.input-group-append' })
  onClickAppend(event: any) {
    $(event.target)
      .parents('.input-group')
      .children('input,.daterange-picker')
      .focus();
  }
}
